import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { MenuItem } from 'primeng/api';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';

import { AuthService } from '../../core/services/auth.service';
import { UserStore } from '../../shared/services/user-store';

@Component({
  selector: 'app-header',
  imports: [IconFieldModule, InputIconModule, InputTextModule, AvatarModule, MenuModule, RouterLink, RouterLinkActive, ButtonModule, DrawerModule],
  templateUrl: './header.html'
})
export class Header {
  private authService = inject(AuthService);
  private userStore = inject(UserStore);

  readonly currentUser = this.userStore.currentUser;
  readonly mobileMenuOpen = signal(false);

  private readonly nameParts = computed(() => {
    const parts = this.currentUser()?.fullName?.trim().split(/\s+/) ?? [];
    return {
      firstName: parts[0] ?? '',
      lastName: parts.length > 1 ? parts.slice(1).join(' ') : ''
    };
  });

  readonly initials = computed(() => {
    const { firstName, lastName } = this.nameParts();
    return ((firstName[0] ?? '') + (lastName.split(' ').pop()?.[0] ?? '')).toUpperCase();
  });

  links = [
    { label: 'Dashboard', icon: 'pi-th-large', path: 'dashboard' },
    { label: 'My deals', icon: 'pi-briefcase', path: 'deals' },
    { label: 'Resources', icon: 'pi-book', path: 'resources' }
  ];

  userMenuItems: MenuItem[] = [
    { label: 'Logout', icon: 'pi pi-sign-out', command: () => this.logout() }
  ];

  submitNewDeal() {
    const email = this.currentUser()?.email;
    const { firstName, lastName } = this.nameParts();

    const url = new URL('https://application.avanacapital.com');
    if (email) url.searchParams.set('email', email);
    if (firstName) url.searchParams.set('firstname', firstName);
    if (lastName) url.searchParams.set('lastname', lastName);

    window.open(url.toString(), '_blank', 'noopener');
  }

  logout() {
    this.authService.logout();
  }
}
